import React, { useState } from 'react';
import { Checkbox, Pagination } from '@jjj/components';
import { t } from '../../../../../../../../i18n';
import { PaginationWrapper, PositionsWrapper } from './choosePosition.style';

const PAGE_SIZE = 5;

export function ChoosePosition({ selectedPositions, onChange, selectedTalent }) {
  const [page, setPage] = useState(1);

  const paginatePositions = (elements, pageSize) => {
    const positions = elements.map(skill => skill.position);
    const paginatedPositions = [];

    if (positions.length) {
      for (let i = 0; i < positions.length; i += pageSize) {
        paginatedPositions.push(positions.slice(i, i + pageSize));
      }
    }

    return paginatedPositions;
  };

  const onPaginationChange = newPage => setPage(newPage);

  if (!selectedTalent) {
    return null;
  }

  const paginatedPositions = paginatePositions(selectedTalent.skills, PAGE_SIZE);
  const isPaginationVisible = selectedTalent?.skills?.length > PAGE_SIZE;
  const talent = `${selectedTalent?.first_name} ${selectedTalent?.last_name}`;

  return (
    <div>
      <div>{t('dash.units.unit.my_team.add_talent_modal.select_position_label', { talent })}</div>

      {paginatedPositions?.[page - 1]?.length > 0 && (
        <PositionsWrapper>
          <Checkbox.Group
            onChange={event => {
              onChange({
                attr: 'positions',
                value: {
                  ...selectedPositions,
                  [page]: event,
                },
              });
            }}
          >
            {paginatedPositions[page - 1].map(({ id, name }) => (
              <Checkbox key={id} value={id} data-cy="unit-my_team-add_applicant_modal-steps-chose_position">
                {name}
              </Checkbox>
            ))}
          </Checkbox.Group>

          {isPaginationVisible && (
            <PaginationWrapper>
              <Pagination
                size="small"
                total={selectedTalent?.skills?.length}
                pageSize={PAGE_SIZE}
                onChange={onPaginationChange}
              />
            </PaginationWrapper>
          )}
        </PositionsWrapper>
      )}
    </div>
  );
}
